import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Popconfirm } from "antd";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

import menuImage from "../../assets/images/menu.svg";
import Image from "../../assets/images/logoteamex.jpg";
import { getUserIcon } from "../../utils/images";

import {
  adminDashboardMenu,
  userDashboardMenu,
  wareHouseDashboardMenu,
} from "../../helper/sidebarPath/SidebarPath";

import COLORS from "../../constants/colors"; // <-- import color constants
import { QueryClient } from "@tanstack/react-query";
import { notifySuccess } from "../../utils/ToastifyProvider";

const Sidebar = ({ isOpen, setIsOpen, userType, userId }) => {
  const [subMenuOpen, setSubMenuOpen] = useState("");

  const navigate = useNavigate();

  const firstname = localStorage.getItem("firstName") || {};
  const lastname = localStorage.getItem("lastName") || {};
  const gender = localStorage.getItem("gender") || {};
  const queryClient = new QueryClient();

  let userRoutes = [];
  if (userType === "admin") userRoutes = adminDashboardMenu;
  else if (userType === "warehouse") userRoutes = wareHouseDashboardMenu;
  else userRoutes = userDashboardMenu;

  const handleLogout = () => {
    // Clear react-query cache + local storage
    queryClient.clear();
    localStorage.clear();
    notifySuccess("Logout successful! Redirecting...");

    // Wait 2 seconds, then refresh & redirect
    setTimeout(() => {
      navigate("/login", { replace: true });
      window.location.reload();
    }, 2000);
  };

  return (
    <aside
      className={`h-screen bg-white border-r border-gray-200 flex flex-col justify-between transition-all duration-300 ${
        isOpen ? "w-64" : "w-20"
      }`}
    >
      {/* Top Logo and Toggle */}
      <div className="flex flex-col items-center mt-6 relative">
        <img
          src={Image}
          alt="Logo"
          className={`transition-all duration-300 ${
            isOpen ? "w-40 mb-4" : "w-10 mb-2"
          }`}
        />
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="absolute top-0 right-2"
        >
          <img src={menuImage} alt="Toggle" className="w-5" />
        </button>
      </div>

      {/* Menu */}
      <nav className="flex-1 mt-4 space-y-1">
        {userRoutes.map((route) =>
          route.submenu?.length ? (
            <div key={route.name}>
              <button
                onClick={() =>
                  setSubMenuOpen(subMenuOpen === route.name ? "" : route.name)
                }
                className={`flex items-center w-full px-4 py-2 text-sm font-medium ${
                  subMenuOpen === route.name
                    ? `bg-[${COLORS.primaryLight}] text-[${COLORS.primary}]`
                    : `text-gray-700 hover:bg-[${COLORS.primaryLight}] hover:text-[${COLORS.primary}]`
                }`}
              >
                <span className="mr-3">{route.icon}</span>
                {isOpen && <span>{route.name}</span>}
                {isOpen && (
                  <span className="ml-auto">
                    {subMenuOpen === route.name ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </span>
                )}
              </button>
              {subMenuOpen === route.name && (
                <div className="pl-10">
                  {route.submenu.map((sub) => (
                    <NavLink
                      key={sub.name}
                      to={sub.path}
                      className={({ isActive }) =>
                        `flex items-center px-4 py-2 text-sm font-medium ${
                          isActive
                            ? `text-[${COLORS.primary}] bg-[${COLORS.primaryLight}]`
                            : `text-gray-600 hover:text-[${COLORS.primary}] hover:bg-[${COLORS.primaryLight}]`
                        }`
                      }
                    >
                      <span className="mr-3">{sub.icon}</span>
                      {isOpen && <span>{sub.name}</span>}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <NavLink
              key={route.name}
              to={route.path}
              className={({ isActive }) =>
                `flex items-center px-4 py-2 text-sm font-medium ${
                  isActive
                    ? `text-[${COLORS.primary}] bg-[${COLORS.primaryLight}]`
                    : `text-gray-700 hover:text-[${COLORS.primary}] hover:bg-[${COLORS.primaryLight}]`
                }`
              }
            >
              <span className="mr-3">{route.icon}</span>
              {isOpen && <span>{route.name}</span>}
            </NavLink>
          )
        )}
      </nav>

      {/* Profile */}
      {/* Profile */}
      <div
        className={`border-t border-gray-200 p-4 bg-[${COLORS.primaryLight}]`}
      >
        <div className="flex items-center justify-between space-x-3">
          <div className="flex items-center space-x-3">
            <img
              src={getUserIcon(gender, userId)}
              alt="User"
              className="w-10 h-10 rounded-full"
            />
            {isOpen && (
              <div>
                <div
                  className={`text-sm font-medium text-[${COLORS.textBlack}]`}
                >
                  {firstname || lastname
                    ? `${firstname || ""} ${lastname || ""}`.trim()
                    : ""}
                </div>
                <div className="text-xs text-gray-500 capitalize">
                  {userType}
                </div>
              </div>
            )}
          </div>

          {isOpen && (
            <Popconfirm
              title="Are you sure you want to logout?"
              onConfirm={handleLogout}
              okText="Yes"
              cancelText="No"
              placement="topRight"
            >
              <button className="text-[18px] text-gray-700 hover:text-red-500 transition-all">
                &gt;
              </button>
            </Popconfirm>
          )}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
